<template>
  <div class="file-picker-input">
    <div class="input-group">
      <div class="input-group-prepend">
        <button
            type="button"
            ref="pickerButton"
            class="btn btn-primary text-white"
        >
          <i class="fa fa-image-o"></i> Choose
        </button>
      </div>
      <input
          :id="inputId"
          ref="fileInput"
          :value="modelValue"
          type="text"
          class="form-control"
          :placeholder="placeholder"
          @input="handleInput"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilePickerInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    mediaType: {
      type: String,
      default: 'file',
      validator: (value) => ['image', 'audio', 'video', 'file'].includes(value)
    },
    placeholder: {
      type: String,
      default: 'Select file...'
    },
    inputId: {
      type: String,
      required: true,
      validator: (value) => /^[a-zA-Z_-][a-zA-Z0-9_-]*$/.test(value)
    }
  },
  emits: ['update:modelValue', 'error'],
  data() {
    return {
      isUpdatingFromFileManager: false
    }
  },
  mounted() {
    this.initializeFilePicker()
    this.setupInputListener()
  },
  beforeUnmount() {
    this.cleanupFilePicker()
  },
  methods: {
    initializeFilePicker() {
      if (typeof $ === 'undefined') {
        if (window.lfm) {
          window.lfm(`#${this.inputId}`, 'stand-alone-button')
        }
        return
      }

      const $button = $(this.$refs.pickerButton)
      $button.attr('data-input', this.inputId)
      $button.attr('data-lfm', this.mediaType)

      try {
        $button.filemanager(this.mediaType, { prefix: '/filemanager' })
      } catch (e) {
        console.warn('File manager initialization failed:', e)
        this.$emit('error', e)
      }
    },
    setupInputListener() {
      if (typeof $ === 'undefined') {
        return
      }

      const $input = $(`#${this.inputId}`)

      $input.off('change.filepicker').on('change.filepicker', (e) => {
        const newValue = $(e.target).val()
        if (newValue !== this.modelValue) {
          this.isUpdatingFromFileManager = true
          this.$emit('update:modelValue', newValue)
          this.$nextTick(() => {
            this.isUpdatingFromFileManager = false
          })
        }
      })
    },
    cleanupFilePicker() {
      if (typeof $ === 'undefined') {
        return
      }

      const $input = $(`#${this.inputId}`)
      $input.off('change.filepicker')

      const $button = $(this.$refs.pickerButton)
      $button.off('click')
    },
    handleInput(event) {
      const newValue = event.target.value
      if (newValue !== this.modelValue) {
        this.$emit('update:modelValue', newValue)
      }
    }
  },
  watch: {
    modelValue(newValue) {
      if (this.isUpdatingFromFileManager) {
        return
      }

      if (this.$refs.fileInput && this.$refs.fileInput.value !== newValue) {
        this.$refs.fileInput.value = newValue
      }

      if (typeof $ !== 'undefined') {
        const $input = $(`#${this.inputId}`)
        if ($input.val() !== newValue) {
          $input.val(newValue)
        }
      }
    },
    mediaType() {
      this.cleanupFilePicker()
      this.$nextTick(() => {
        this.initializeFilePicker()
        this.setupInputListener()
      })
    }
  }
}
</script>

<style scoped>
.file-picker-input {
  width: 100%;
}
</style>